import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { BudgetService } from './budget.service';

export const budgetGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(BudgetService).access().pipe(
    map(result => result.allowed || router.createUrlTree(['/access-denied'])),
    catchError(() => of(router.createUrlTree(['/access-denied'])))
  );
};
